"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ItemSummary;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _reactIntersectionObserver = require("react-intersection-observer");
var _text = _interopRequireDefault(require("@ux/text"));
var _price = require("@site/pattern-library-core/price");
var _configContext = require("../context/config-context");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _image = require("@site/pattern-library-core/image");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _splitPanelItem = _interopRequireDefault(require("../common/split-panel-item"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _fixedCheckout = _interopRequireDefault(require("./fixed-checkout"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _klarnaMerchandising = _interopRequireDefault(require("@site/pattern-library-core/klarna-merchandising"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 **/

const ItemSummaryContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ItemSummaryContainer",
  class: "pc-i1lzumh9"
});
const TitleContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TitleContainer",
  class: "pc-t2z69ex"
});
const ItemsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ItemsContainer",
  class: "pc-i1h9lyqq"
});
const SubTotalContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SubTotalContainer",
  class: "pc-s7xoxr3"
});
const ProductContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ProductContent",
  class: "pc-p1cvdfz7"
});
const ProductImg = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "ProductImg",
  class: "pc-pq8msta"
});
const CornerBorder = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CornerBorder",
  class: "pc-c77ngl"
});
const FlexColumnContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlexColumnContainer",
  class: "pc-f1svv264"
});
const PriceContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceContent",
  class: "pc-p1em59ox"
});
const TotalSavingContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TotalSavingContainer",
  class: "pc-t8zbyn5"
});
const CtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaContainer",
  class: "pc-cu7s6ej",
  vars: {
    "cu7s6ej-0": [({
      loading
    }) => loading ? '0.5' : '1'],
    "cu7s6ej-1": [({
      loading
    }) => loading ? 'none' : 'auto']
  }
});
const renderSavingsText = (banner, value) => {
  if (!banner?.includes('{value}')) return banner;
  const [before, after] = banner.split('{value}');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, before, /*#__PURE__*/_react.default.createElement("b", null, value), after);
};
function ItemSummary({
  id,
  title,
  items,
  subTotal,
  totalSavings,
  viewCartCta,
  checkoutCta,
  loading,
  klarnaActive = false
}) {
  const {
    ref,
    inView
  } = (0, _reactIntersectionObserver.useInView)();
  const summaryRef = (0, _react.useRef)(null);
  const {
    paymentConfigUrl
  } = (0, _configContext.useConfig)();
  const subTotalFourPayments = Number(subTotal.subTotal.replace(/[^0-9.-]+/g, '')) * 1000000;
  const titleText = /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    className: "item-summary-title",
    "data-cy": "item-summary-title",
    text: title,
    size: 1
  });
  const itemsContainer = /*#__PURE__*/_react.default.createElement(ItemsContainer, {
    "data-cy": "items-container"
  }, items.map((item, i) => {
    const isDomainProtection = item.productType === 'domainprotection';
    const productContent = /*#__PURE__*/_react.default.createElement(ProductContent, item.instancePath && {
      'data-pc-selection': item.instancePath
    }, !isDomainProtection && item.image && /*#__PURE__*/_react.default.createElement(ProductImg, (0, _extends2.default)({
      dataCy: "item-image"
    }, item.image)), isDomainProtection && /*#__PURE__*/_react.default.createElement(CornerBorder, {
      "data-cy": "corner-border"
    }), /*#__PURE__*/_react.default.createElement(FlexColumnContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
      "data-cy": "item-name",
      as: "title",
      className: "item-summary-title",
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(item.productName)
      },
      size: 0
    }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
      "data-cy": "item-term-length",
      as: "paragraph",
      text: item.productLength,
      size: -1
    }), item.renewalPrice && /*#__PURE__*/_react.default.createElement(_text.default.p, {
      "data-cy": "item-renewal",
      as: "paragraph",
      text: item.renewalPrice,
      size: -1
    })));
    const priceContent = /*#__PURE__*/_react.default.createElement(PriceContent, null, item.tag && /*#__PURE__*/_react.default.createElement(_tag.default, {
      "data-cy": "item-savings-tag",
      text: item.tag,
      design: "warning",
      size: "sm"
    }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "title",
      "data-cy": "item-today-price",
      text: item.todayPrice,
      size: 0
    }), item.oldPrice && /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "paragraph",
      "data-cy": "strikethru-price",
      className: `text-uppercase ${_price.oldTagStyles}`,
      text: item.oldPrice,
      size: -1
    }));
    return /*#__PURE__*/_react.default.createElement(_splitPanelItem.default, {
      key: `item-summary-${i}`,
      style: {
        backgroundColor: 'red'
      },
      startAlignedContent: productContent,
      endAlignedContent: priceContent
    });
  }));
  const subTotalContent = /*#__PURE__*/_react.default.createElement(FlexColumnContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    "data-cy": "item-summary-subtotal-title",
    className: "item-summary-title",
    size: 2
  }, subTotal.title), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    "data-cy": "item-summary-subtotal-description",
    size: -1
  }, subTotal.description), paymentConfigUrl && klarnaActive && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_klarnaMerchandising.default, {
    "data-cy": "klarna-merchandising",
    paymentConfigUrl: paymentConfigUrl,
    price: subTotalFourPayments
  })));
  const subTotalPrice = /*#__PURE__*/_react.default.createElement(PriceContent, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    "data-cy": "item-summary-subtotal",
    className: "item-summary-title",
    size: 2
  }, subTotal.subTotal));
  const totalSavingsContainer = /*#__PURE__*/_react.default.createElement(TotalSavingContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    "data-cy": "total-savings",
    size: -1
  }, renderSavingsText(totalSavings.banner, totalSavings.value)));
  if (viewCartCta) {
    viewCartCta.design = 'secondary';
    viewCartCta.templateName = 'Button Component';
  }
  checkoutCta.templateName = 'Button Component';
  checkoutCta.design = 'primary';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ItemSummaryContainer, {
    id: `id-${id}`,
    ref: ref,
    "data-cy": "item-summary-container"
  }, /*#__PURE__*/_react.default.createElement(TitleContainer, {
    ref: summaryRef
  }, /*#__PURE__*/_react.default.createElement(_splitPanelItem.default, {
    startAlignedContent: titleText
  })), itemsContainer, /*#__PURE__*/_react.default.createElement(SubTotalContainer, null, /*#__PURE__*/_react.default.createElement(_splitPanelItem.default, {
    startAlignedContent: subTotalContent,
    endAlignedContent: subTotalPrice
  })), totalSavings.value && totalSavings.banner && totalSavingsContainer, /*#__PURE__*/_react.default.createElement(CtaContainer, {
    loading: loading,
    'data-partial': 'bluectas'
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [viewCartCta, checkoutCta]
  }))), /*#__PURE__*/_react.default.createElement(_fixedCheckout.default, {
    parentVisible: inView,
    scrollRef: summaryRef,
    checkoutCta,
    title: subTotal.title,
    subTotal: subTotal.subTotal,
    description: subTotal.fixedCheckoutDescription
  }));
}
ItemSummary.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    instancePath: _propTypes.default.string,
    image: _propTypes.default.shape(_image.imgPropShape),
    productName: _propTypes.default.string,
    productLength: _propTypes.default.string,
    renewalPrice: _propTypes.default.string,
    tag: _propTypes.default.string,
    todayPrice: _propTypes.default.string,
    originalPrice: _propTypes.default.string
  })),
  subTotal: _propTypes.default.shape({
    subTotal: _propTypes.default.string,
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    fixedCheckoutDescription: _propTypes.default.string
  }),
  totalSavings: _propTypes.default.shape({
    banner: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  viewCartCta: _propTypes.default.object,
  checkoutCta: _propTypes.default.object,
  loading: _propTypes.default.bool,
  klarnaActive: _propTypes.default.bool
};